import _ from 'lodash';
import { connect } from 'react-redux';
import { getAddressFromZip } from 'client/actions/geo';
import { saveAddressToApp } from 'client/actions/address';
import ZipcodeLookupPage from 'routes/vision/components/zipcodeLookupPage';
import { subscribe } from 'client/actions/preRegistration';

const mapStateToProps: Object = state => ({
  contentfulData: state.contentfulData,
  geo: state.geo,
  members: state.members,
  user: state.user,
  visionApp: _.find(state.ifpApps, { type: 'vision' }),
  enableDentalVisionEmailCollection: _.get(state, "launchDarkly.flags['enable-dental-vision-email-collection']", false) && !state.user.isLoggedIn,
});

export default connect(mapStateToProps, {
  getAddressFromZip,
  saveAddressToApp,
  subscribe,
})(ZipcodeLookupPage);
